import React from 'react';
import classnames from 'classnames';

const BillingFrequencySwitcherButton = ({
  currentlySetFrequency,
  setFrequency,
  frequency,
}: any) => {
  const sharedClassNames =
    'relative w-1/2 rounded-md py-2 text-sm font-medium whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-primary-600 focus:z-10 sm:w-auto sm:px-8';
  const activeClassNames = 'bg-primary border-gray-200 shadow-sm text-white';
  const inactiveClassNames = 'ml-0.5 border border-transparent text-gray-700';

  return (
    <button
      type="button"
      onClick={() => {
        setFrequency(frequency);
      }}
      className={classnames(sharedClassNames, {
        [activeClassNames]: currentlySetFrequency === frequency,
        [inactiveClassNames]: currentlySetFrequency !== frequency,
      })}
      id={`currency-switcher-${frequency.toLowerCase()}`}
    >
      {frequency}
    </button>
  );
};

const BillingFrequencySwitcher = (props) => (
  <div className="relative self-center mt-6 bg-gray-100 rounded-lg p-0.5 flex sm:mt-8">
    <BillingFrequencySwitcherButton frequency="Monthly" {...props} />
    <BillingFrequencySwitcherButton frequency="Annual" {...props} />
  </div>
);

export default BillingFrequencySwitcher;
